<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 text-gray-800">View Staff</h2>
        <p><strong>Name:</strong> {{ staff.name }}</p>
        <p><strong>Phone:</strong> {{ staff.phone }}</p>
        <p><strong>Email:</strong> {{ staff.email }}</p>
        <p><strong>Address:</strong> {{ staff.address }}</p>
        <p><strong>Joined Date:</strong> {{ formatDate(staff.createdAt) }}</p>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      staff: {
      },
    },
    methods: {
      closeModal() {
        this.$emit('closeModal'); // Emit event to close the modal
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any custom styles here */
  </style>
  